import { PageTemplate } from '@/components/templates'
import { CONTAINER_SIZES } from '@/constants'

const PerpsScreen = () => {
  return (
    <PageTemplate
      title="Perpetuals Trading"
      subtitle="Trade perpetual futures with leverage up to 100x"
      maxWidth={CONTAINER_SIZES.WIDE}
    >
      <div className="flex items-center justify-center h-[60vh]">
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-2">Coming Soon</h3>
          <p className="text-gray-500">
            Perpetuals trading is currently under development
          </p>
        </div>
      </div>
    </PageTemplate>
  )
}

export default PerpsScreen 